import { Component, inject } from "@angular/core";
import { Platform } from "@ionic/angular";



@Component({
    template: `
    <!-- <ion-split-pane contentId="main">
    <ion-menu
      class="menu"
      #mainmenu
      side="start"
      menuId="first"
      contentId="main"
    >
    <app-sidebar></app-sidebar>
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>

    
  </ion-split-pane>
    <app-tabbar style="position:fixed;bottom:0;width:100%"></app-tabbar> -->
    <ion-split-pane [when]="platform.is('desktop')" contentId="main">
      <ion-menu contentId="main" class="w-screen" style="--width: 100vw">
        <ion-content>
          <app-sidebar></app-sidebar>
        </ion-content>
      </ion-menu>

      <div class="ion-page" id="main">
        <ion-content [fullscreen]="true">
          <ion-router-outlet></ion-router-outlet>
          <app-tabbar *ngIf="!platform.is('desktop')" style="position:fixed;bottom:0;width:100%"></app-tabbar>
        </ion-content>
      </div>
    </ion-split-pane>
    `
})
export class TabbarLayout {
  platform = inject(Platform)
}